import { render } from "./CourseOption.vue?vue&type=template&id=48d72c89&scoped=true"
import script from "./CourseOption.vue?vue&type=script&lang=js"
export * from "./CourseOption.vue?vue&type=script&lang=js"

import "./CourseOption.vue?vue&type=style&index=0&id=48d72c89&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d72c89"]])

export default __exports__